import { Alert, AlertTitle, type AlertProps } from '@mui/material';
import type { ReactNode } from 'react';

export type AlertMessageProps = Omit<AlertProps, 'children' | 'title'> & {
  title?: ReactNode;
  children: ReactNode;
};

export function AlertMessage({
  title,
  children,
  icon,
  severity = 'info',
  variant = 'standard',
  ...rest
}: AlertMessageProps) {
  return (
    <Alert icon={icon} severity={severity} variant={variant} {...rest}>
      {title ? <AlertTitle>{title}</AlertTitle> : null}
      {children}
    </Alert>
  );
}
